"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sampleRange = exports.evaluateSeriesAt = exports.SERIES = exports.factorial = void 0;
const FACTORIAL_CACHE = [1];
const factorial = (n) => {
    for (let i = FACTORIAL_CACHE.length; i <= n; i++) {
        FACTORIAL_CACHE[i] = FACTORIAL_CACHE[i - 1] * i;
    }
    return FACTORIAL_CACHE[n];
};
exports.factorial = factorial;
exports.SERIES = [
    { key: 'exp', label: 'e^x', f: (x) => Math.exp(x), coeff: (n) => 1 / (0, exports.factorial)(n), domain: { min: -3, max: 3 }, note: 'Converges for all real x.' },
    { key: 'sin', label: 'sin(x)', f: (x) => Math.sin(x), coeff: (n) => (n % 2 === 0 ? 0 : (n % 4 === 1 ? 1 : -1) / (0, exports.factorial)(n)), domain: { min: -Math.PI * 2, max: Math.PI * 2 }, note: 'Odd function; nonzero terms are odd powers.' },
    { key: 'cos', label: 'cos(x)', f: (x) => Math.cos(x), coeff: (n) => (n % 2 === 1 ? 0 : (n % 4 === 0 ? 1 : -1) / (0, exports.factorial)(n)), domain: { min: -Math.PI * 2, max: Math.PI * 2 }, note: 'Even function; nonzero terms are even powers.' },
    { key: 'ln1p', label: 'ln(1 + x)', f: (x) => Math.log(1 + x), coeff: (n) => (n === 0 ? 0 : ((n % 2 === 1 ? 1 : -1) / n)), domain: { min: -0.95, max: 2 }, note: 'Converges for |x| < 1; conditional at x = 1.' },
    { key: 'atan', label: 'arctan(x)', f: (x) => Math.atan(x), coeff: (n) => (n % 2 === 0 ? 0 : ((n % 4 === 1 ? 1 : -1) / n)), domain: { min: -3, max: 3 }, note: 'Converges for |x| ≤ 1; slower near ±1.' },
    { key: 'geom', label: '1 / (1 − x)', f: (x) => 1 / (1 - x), coeff: (n) => 1, domain: { min: -0.9, max: 0.9 }, note: 'Geometric series; converges for |x| < 1.' },
    { key: 'sinh', label: 'sinh(x)', f: (x) => Math.sinh(x), coeff: (n) => (n % 2 === 1 ? 1 / (0, exports.factorial)(n) : 0), domain: { min: -3, max: 3 }, note: 'Odd hyperbolic sine; odd powers only.' },
    { key: 'cosh', label: 'cosh(x)', f: (x) => Math.cosh(x), coeff: (n) => (n % 2 === 0 ? 1 / (0, exports.factorial)(n) : 0), domain: { min: -3, max: 3 }, note: 'Even hyperbolic cosine; even powers only.' },
    { key: 'atanh', label: 'arctanh(x)', f: (x) => Math.atanh(x), coeff: (n) => (n % 2 === 1 ? 1 / n : 0), domain: { min: -0.9, max: 0.9 }, note: 'Converges for |x| < 1; singularities at x = ±1.' },
    { key: 'inv1px', label: '1 / (1 + x)', f: (x) => 1 / (1 + x), coeff: (n) => (n % 2 === 0 ? 1 : -1), domain: { min: -0.9, max: 0.9 }, note: 'Alternating geometric series; converges for |x| < 1.' },
    { key: 'sinc', label: 'sinc(x) = sin(x)/x', f: (x) => (x === 0 ? 1 : Math.sin(x) / x), coeff: (n) => { if (n === 0)
            return 1; if (n % 2 === 1)
            return 0; const k = n / 2; return (k % 2 === 0 ? 1 : -1) / (0, exports.factorial)(2 * k + 1); }, domain: { min: -8, max: 8 }, note: 'Even function with oscillatory decay; uses even powers only.' },
];
function evaluateSeriesAt(series, x, terms) {
    let sum = 0;
    let xPow = 1;
    for (let n = 0; n < terms; n++) {
        const a = series.coeff(n);
        sum += a * xPow;
        xPow *= x;
    }
    return sum;
}
exports.evaluateSeriesAt = evaluateSeriesAt;
function sampleRange(min, max, samples) {
    const step = (max - min) / (samples - 1);
    const xs = [];
    for (let i = 0; i < samples; i++)
        xs.push(min + i * step);
    return xs;
}
exports.sampleRange = sampleRange;
